<template>
  <div>
    <v-dialog content-class="dialog-rotate" v-if="inRotationMode" v-model="inRotationMode" persistent max-width="350">
      <v-card>
        <v-card-title>
          Rotación
          <v-spacer></v-spacer>
            <v-btn icon @click="toggleRotationMode" v-if="rotateProgressState!='running'">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>                  
        <JobProgress v-model="rotateProgressState" :job_id="rotateJobId" v-on:done="rotateDone" v-on:error="rotateDone">
          <template v-slot:progress>
            <v-card-text>
              <div class="d-flex justify-center pt-10">
                <v-progress-circular indeterminate color="secundary" />
              </div>
            </v-card-text>
          </template>
          <template v-slot:quiet>
            <v-card-text>
              <div class="d-flex justify-center pt-10" v-if="rotateJobId">
                <v-progress-circular indeterminate color="secundary" />
              </div>
              <v-row class="pl-4 pr-4 pt-2" v-else>
                <v-col cols="12">
                  <v-btn-toggle
                    class="btn-toogle-rotation d-flex flex-column" 
                    mandatory
                    v-model="rotationPageMode" 
                    @change="setRotationMode">
                    <v-btn class="mb-6 justify-start btn-rotation" value="all" style="border-color:#65379C !important;">
                      <img class="pa-2" left src="/invoices/rotate_document.png"/>
                      Todo el documento
                    </v-btn>
                    <v-btn class="justify-start btn-rotation" value="page" style="border-color:#65379C !important;">
                      <img class="pa-2" left src="/invoices/rotate_page.png"/>
                      Por página
                    </v-btn>
                  </v-btn-toggle>

                  
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn rounded color="primary" outlined @click="cancelRotationMode()">
                Cancelar
              </v-btn>         
              <v-btn rounded color="primary" @click="doRotation()">
                Guardar rotación
              </v-btn>          
            </v-card-actions>
          </template>
        </JobProgress>        
        
      </v-card>
    </v-dialog>
    <div class="header-pdf-document">
      <div class="title">Detalle Factura</div>
      <v-spacer></v-spacer>
      <div class="action-controls">
        <v-btn color="primary" class="action-btn-doc" fab small icon @click="downloadDocument()" v-if="!$vuetify.breakpoint.md">
          <img src="/invoices/download.svg"/>  
        </v-btn>
        <div class="group" v-if="!$vuetify.breakpoint.md">
          <show-boxes-btn :key="currentDocument.id.toString()" v-if="currentDocument" stylev2/>
          <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom >= maxZoom" @click="increaseZoom">
          <img src="/invoices/zoom_in.svg"/>
          </v-btn>
          <v-btn color="primary" class="action-btn-doc" fab small icon :disabled="zoom <= minZoom" @click="decreaseZoom">
            <img src="/invoices/zoom_out.svg"/>
          </v-btn>
          <v-btn color="primary" class="action-btn-doc" fab small icon @click="toggleRotationMode">
            <img src="/invoices/rotate.svg"/>        
          </v-btn>        
        
          <app-confirm-modal
            v-model="deleteDocumentDialog"
            :text-msg="deleteDocumentMsg"
            @confirm="confirmDeleteDocument()"
            @cancel="noDeleteDocument()"
          >
          </app-confirm-modal>
          <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone" >
            <template v-slot:progress>
              <v-btn fab small loading icon></v-btn>
            </template>
            <template v-slot:quiet>
              <v-btn 
              v-if="userData && userData.user_role.value != 'customer' && userData.user_role.value != 'customer_consult'"
              color="primary" 
              class="action-btn-doc" fab small icon 
              :loading="deleting || Boolean(deleteJobId)" 
              @click="confirmDialogDeleteDocument()"
              >
                <img src="/invoices/delete.svg"/>  
              </v-btn>
            </template>
          </JobProgress>
        </div>

        <v-btn 
        v-if="!permission.general.is_customer_consult"
        class="btn-upload" 
        depressed 
        @click="$router.push({name: 'document-loader', params: {'company_id': currentCompany.id}})"
        >          
          <v-icon height="20" width="20">mdi-file-upload-outline</v-icon>
          {{ uploadInvoiceLabel }}
        </v-btn>
      </div>
    </div>

    
    <div class="vertical-controls d-flex flex-column" v-if="$vuetify.breakpoint.md">
      <show-boxes-btn :key="currentDocument.id.toString()" v-if="currentDocument" stylev2/>
      <v-btn color="primary" fab small icon :disabled="zoom >= maxZoom" @click="increaseZoom">
        <img src="/invoices/zoom_in.svg"/>
      </v-btn>
      <v-btn color="primary" fab small icon :disabled="zoom <= minZoom" @click="decreaseZoom">
        <img src="/invoices/zoom_out.svg"/>
      </v-btn>      
      <v-btn color="primary" fab small icon @click="toggleRotationMode">
        <img src="/invoices/rotate.svg"/>        
      </v-btn>   
      <v-btn color="primary" fab small icon @click="downloadDocument()">
        <img src="/invoices/download.svg"/>  
      </v-btn>
      <app-confirm-modal
        v-model="deleteDocumentDialog"
        :text-msg="deleteDocumentMsg"
        @confirm="confirmDeleteDocument()"
        @cancel="noDeleteDocument()"
      >
      </app-confirm-modal>
      <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone" >
        <template v-slot:progress>
          <v-btn fab small loading icon></v-btn>
        </template>
        <template v-slot:quiet>
          <v-btn color="primary" fab small icon :loading="deleting || Boolean(deleteJobId)" @click="confirmDialogDeleteDocument()">
            <img src="/invoices/delete.svg"/>  
          </v-btn>
        </template>
      </JobProgress>
    </div>
    
    <div v-if="showRotation" class="controls d-flex justify-start" v-bind:style="{ zoom: counterZoom, 'z-index':'210' }">
      <v-btn class="mr-2" color="primary" outlined fab small @click="rotate(-90)">
        <img src="/invoices/rotate_left.png" width="24" height="24">
        
      </v-btn>
      <v-btn color="primary" outlined fab small @click="rotate(90)">
        <img src="/invoices/rotate_right.png" width="24" height="24">        
      </v-btn>
    </div>
    <div class="wraper-pdf-document" v-if="scroll">
      <ScrollingDocument
        class="pdf-document"
        v-bind:style="{ zoom }"
        v-bind="{pages, pageCount, currentPage}"
        v-slot="{page, isPageFocused, isElementFocused}"
        :enable-page-jump="true"
        @page-jump="onPageJump"
        @pages-fetch="onPagesFetch"
        @pages-reset="fitWidth"
        >
        <PDFPageV2
          v-bind="{scale, optimalScale, page, isPageFocused, isElementFocused, pageCount}"
          @page-rendered="onPageRendered"
          @page-errored="onPageErrored"
          @page-focus="onPageFocused"
        />
      </ScrollingDocument>
    </div>
    <div class="wraper-pdf-document" v-else>
        <!-- chapuza total -->
        <PDFViewerV3 :hide_options="true"
        :url="url" :key="'keyv'+url.toString()">
      </PDFViewerV3>
    </div>
  </div>
</template>

<script>
// PDFDocument renders an entire PDF inline using
// PDF.js and <canvas>. Currently does not support,
// rendering of selected pages (but could be easily
// updated to do so).
import { mapGetters, mapActions } from "vuex"
import {PIXEL_RATIO, VIEWPORT_RATIO, PIXEL_RATIO_DEVICE} from '../utils/constants';

import { client } from "@/api/client";
import ScrollingDocument from './ScrollingDocument';
import ShowBoxesBtn from './ShowBoxesBtn.vue';
import PDFPageV2 from './PDFPageV2';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import JobProgress from '../components/JobProgress.vue'
import PDFViewerV3 from '../components/pdf/PDFViewerV3.vue'
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";

export default {
  name: 'PDFDocumentV2',

  data() {
    return {
      maxZoom: 3,
      minZoom: 0.1,
      deleteDocumentDialog: false,
      deleteDocumentMsg: 'Se va a eliminar el documento.',
      deleteProgressState: 'none',
      deleteJobId: 0,
      deleting: false,
      rotateProgressState: 'none',
      rotationPageMode: 'all',
      dialogRotate: true,
    }
  },

  components: {
    ScrollingDocument,
    PDFPageV2,
    ShowBoxesBtn,
    AppConfirmModal,
    JobProgress,    
    PDFViewerV3
  },

  props: {
    pages: {
      required: true,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
    optimalScale: {
      type: Number,
    },
    fit: {
      type: String,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    isPreviewEnabled: {
      default: false,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    ...mapGetters([
      "is_mobile",
    ]),
    defaultViewport() {
      if (!this.pages.length) return {width: 0, height:0};
      const [page] = this.pages;

      return page.getViewport(1.0);
    },
    isPortrait() {
      const {width, height} = this.defaultViewport;
      return width <= height;
    },
    showRotation() {
      return this.inRotationMode && this.rotationMode === 'all'
    },
    counterZoom() {
      return 1 / this.zoom
    },
    ...mapGetters({
      zoom: "documents/zoom",
      inRotationMode: "documents/inRotationMode",
      rotationMode: "documents/rotationMode",
      rotateJobId:"documents/rotateJobId",      

      currentDocument: "documents/currentDocument",
      currentCompany: "getCurrentCompany",
      userData: 'me/userData',
      permission: 'permissions/permission',
    }),
    ...mapFields('documents',vuexPrefix('document_',['supplierdb_info', 'customerdb_info', 'kind'],'document.')),
    ...mapFields('documents', ['isBienInversionChanged', 'areIvaChecksChanged']),
    uploadInvoiceLabel(){
      return this.is_mobile ? "" : "Subir Factura"
    },
  },

  methods: {
    ...mapActions({
      setZoom: "documents/setZoom",
      doRotate: 'documents/doRotate',
      downloadFile:"documents/downloadFile",
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
      setRotation:"documents/setRotation",
      setRotationMode:"documents/setRotationMode",
      cancelRotationMode:"documents/cancelRotationMode",
      saveRotation:"documents/saveRotation",
    }),
    /* Download doc */
    downloadDocument() {
      let filename = 'doc_'+this.currentDocument.id.toString();
      if (this.currentDocument.originalFileName) {
        filename += '_'+this.currentDocument.originalFileName;
      }
      else if (this.currentDocument.supplierName) {
        filename += '_'+this.currentDocument.supplierName.replace(' ','_');
      }
      else if(this.currentDocument.customerName) {
        filename += '_'+this.currentDocument.customerName.replace(' ','_');
      }
      if (!filename.endsWith('.pdf') && !filename.endsWith('.PDF')) {
        filename+='.pdf'
      }
      this.downloadFile({"signed_url":this.currentDocument.signed_url,"filename":filename});
    },
    /* Delete doc */
    confirmDialogDeleteDocument() {
      this.deleteDocumentDialog = true;
    },
    noDeleteDocument() {
      this.deleteDocumentDialog = false;
    },
    confirmDeleteDocument() {
      this.deleteDocumentDialog = false;
      this.deleting = true;
      client.post("delete_documents/" , { 'doc_ids': [this.currentDocument.id] }).then(resp => {
        if (Object.keys(resp.data).includes('ko')) {
            this.setMessageModal({
              text: resp.data['ko'],
              actionConfirmButton: this.closeMessageModal
            })
            this.deleting = false;
            this.deleteDocumentDialog = false;
        }
        else {
          this.deleteJobId = resp.data['AsyncJob'];
          this.deleteProgressState = 'running';
        }
      });
    },
    deleteItemDone() {
      this.deleting = false;
      this.deleteJobId = 0;
      this.setMessageModal({
        text: 'El documento se ha borrado correctamente.',
        actionConfirmButton: this.closeMessageModal
      })
      if(!this.currentDocuments){
        this.$router.push({name:'document-list'});
      }
    },
    toggleRotationMode() {
      this.setRotation(!this.inRotationMode)      
    },
    rotate(deg) {
      this.doRotate({rotation: deg})
    },
    doRotation() {
      this.saveRotation().then(() => {
        this.rotateProgressState = "running"
      })
    },
    rotateDone() {
      window.location.reload()
    },
    increaseZoom() {
      const zoom = Math.min(this.zoom + .1, this.maxZoom)
      this.setZoom(zoom)
    },
    decreaseZoom() {
      const zoom = Math.max(this.zoom - .1, this.minZoom)
      this.setZoom(zoom)
    },
    pageWidthScale() {
      const {defaultViewport, $el} = this;
      if (!defaultViewport.width) return 0;
      let ratio = PIXEL_RATIO;
      if (this.permission.is_readonly) {
        ratio = PIXEL_RATIO_DEVICE;
      }
      return ($el.clientWidth * ratio) * VIEWPORT_RATIO / defaultViewport.width;
    },

    pageHeightScale() {
      const {defaultViewport, $el} = this;
      if (!defaultViewport.height) return 0;
      let ratio = PIXEL_RATIO;
      if (this.permission.is_readonly) {
        ratio = PIXEL_RATIO_DEVICE;
      }
      return ($el.clientHeight * ratio) * VIEWPORT_RATIO / defaultViewport.height;
    },
    // Determine an ideal scale using viewport of document's first page, the pixel ratio from the browser
    // and a subjective scale factor based on the screen size.
    fitWidth() {
      const scale = this.pageWidthScale();
      this.updateScale(scale, {isOptimal: !this.optimalScale});
    },

    fitHeight() {
      const scale = this.isPortrait ? this.pageHeightScale() : this.pageWidthScale();
      this.updateScale(scale);
    },

    fitAuto() {
      const scale = Math.min(this.pageWidthScale(), this.pageHeightScale());
      this.updateScale(scale);
    },

    updateScale(scale, {isOptimal = false} = {}) {
      if (!scale) return;
      this.$emit('scale-change', {scale, isOptimal});
    },

    onPageJump(scrollTop) {
      this.$el.scrollTop = scrollTop; // triggers 'scroll' event
    },

    onPagesFetch(currentPage) {
      this.$parent.$emit('pages-fetch', currentPage);
    },

    onPageFocused(pageNumber) {
      this.$parent.$emit('page-focus', pageNumber);
    },

    onPageRendered(payload) {
      this.$parent.$emit('page-rendered', payload);
    },

    onPageErrored(payload) {
      this.$parent.$emit('page-errored', payload);
    },

    // closeModal(modalName) {
    //   this.$modal.hide('modal-supplier');
    // },   
  },

  watch: {
    fit(fit) {
      switch (fit) {
        case 'width':
          this.fitWidth();
          break;

        case 'auto':
          this.fitAuto();
          break;

        default:
          break;
      }
    },
    pageCount: 'fitWidth',
    isPreviewEnabled: 'fitWidth',
  },
};
</script>

<style>
.header-pdf-document {  
  height: 80px;
  background-color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom:1px solid rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);  
  padding-top: 20px;
  padding-bottom:20px;
  display:flex;
  align-items: center;
  padding-left:30px;
  padding-right:20px;
}
.header-pdf-document .title {
  color: #351457;
  font-size:20px;
  font-weight: 700;    
}
.header-pdf-document .action-controls {
  display:flex;  
}
.header-pdf-document .action-controls .group {
  background-color: #F6F6F6;
  border-radius: 10px;
  display:flex;
  height: 32px;
  margin-left:10px;
}
.header-pdf-document .action-controls .action-btn-doc {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 10px;
  background-color: #F6F6F6;
}
.header-pdf-document .action-controls .action-btn-doc:hover {
  background-color: #D1D1D1;
}
.header-pdf-document .action-controls .group > .action-btn-doc:not(:last-child) {
  margin-right:5px;
}

.wraper-pdf-document {
  position: absolute;
  width: -webkit-calc(100% - 12px);
  width: -moz-calc(100% - 12px); 
  width: calc(100% - 12px);
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px); 
  height: calc(100% - 80px);
}
.vertical-controls {
  position: absolute;
  border: 2px solid #66359B;
  border-radius: 5px;
  background-color: #FFFFFF;
  z-index: 100;
  margin-top: 20%;
  left: auto;  
  right: 20px;
  width: 36px;
}
.vertical-controls .v-btn--fab {
  width: 32px;
  height: 32px;
}
.controls {
  position: absolute;
  z-index: 100;
  margin-top: 15px;
  left: 15px;
}
.controls-end {
  left: auto;
  right: 30px;
}
.controls button {
  background-color: white;
}
.pdf-document {
  position: absolute;
  overflow: auto;  
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #525f69;
}

.scrolling-page {
  margin-bottom: 1em;
}

.dialog-rotate {
    border: 1px solid #65379C !important;
    border-radius: 10px !important;    
}
.dialog-rotate .v-card__title {
  border-bottom: 1px solid #65379C;
  color: #65379C;
}
.dialog-rotate .v-card__title .v-icon {
  color: #65379C;
}
.dialog-rotate .v-card__actions {
  padding: 16px 24px;
  justify-content: space-around;
}
.dialog-rotate .v-card__actions .v-btn {
  font-size:11px;
  padding-left: 20px;
  padding-right:20px;
}

.btn-toogle-rotation .v-btn {
  border:1px solid #65379C !important;    
  border-radius: 5px !important;
  background-color: white !important;
  color:#56565B;
  text-transform: capitalize !important;
  font-weight: 300;
  height: 40px !important;
}
.btn-toogle-rotation > .v-btn.v-btn--active {
  background-color: #DEDCFF !important;
  font-weight: 400;
}

@media print {
  .pdf-document {
    position: static;
  }
}
</style>
<style scoped>
  .scrollable-card {
    /* height:600px; 
    width:1000px;  */
    height:100%; 
    width:100%;
    overflow: auto;
  }
  .primary-bckground {
    background-color: #663399;
  }
  .primary-border {
    border-color: #663399 !important;
  }  
 
  .header-pdf-document .action-controls .btn-upload {
    border-radius:10px;
    background-color: #F9F6FE !important;
    color: #66359B;
    border:1px solid #66359B;
    text-transform:capitalize;
    letter-spacing: 1px;
    height: 32px;
    margin-left:10px;
  }
  .header-pdf-document .action-controls .btn-upload .v-icon {
    font-size:20px;
  }
</style>